import React, { FormEvent, useContext, useEffect } from "react";
import { useState } from "react";
import {Grid,Tab,Form,Input,Select,Button,Table, Confirm, Header, Segment, GridColumn, Divider, Image} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import MobileStore from "../../../app/stores/mobileStore";
import { IProjectPermit } from "../../../app/models/projectpermit";
import { IProjectVendor } from "../../../app/models/projectvendor";

const MobilePermitTab = () => {
  const mobileStore = useContext(MobileStore);
  const {
    project,
    projectpermitsByTime,
    loadProjectPermits,
    createProjectPermit,
    deleteProjectPermit,
    addProjectPermit,
    projectaccessByTime,
    loadProjectAccess,
    createProjectAccess,
    deleteProjectAccess,
    addProjectAccess,
    editTechnicianInduction,
    updateProjectAccessStatus,
    TechInduction,
    technicianallRegistry,
    target,
    submitting,
  } = mobileStore;

  useEffect(() => {
    loadProjectPermits(project!.id);
    loadProjectAccess();
  }, []);

  const initialPermitForm: IProjectPermit = {
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    code: "",
    type: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    remark: "",
  };

  const initialAccessForm: IProjectVendor = {
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    type: "Access",
    companyName: "",
    status: "",
    attachment: "",
    remark: "",
    phone: "",
    email: "",
  };

  const [projectPermit, setProjectPermit] = useState<IProjectPermit>(initialPermitForm);
  const [projectAccess, setProjectAccess] = useState<IProjectVendor>(initialAccessForm);
  const [openPermit, setOpenPermit] = useState(false);
  const [openAccess, setOpenAccess] = useState(false);
  const [projectpermitId, setProjectPermitId] = useState("");
  const [projectaccessId, setProjectAccessId] = useState("");

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectPermit({ ...projectPermit, [name]: value });
  };

  const handleAccessInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectAccess({ ...projectAccess, [name]: value });
  };

  const typeOptions = [{ key: "Hazard", text: "Hazard", value: "Hazard" },
                    { key: "Outage", text: "Outage", value: "Outage" }];
  
  const statusOptions = [{ key: "In-progress", text: "In-progress", value: "In-progress" },
                    { key: "Approved", text: "Approved", value: "Approved" }];

  return (
    <Tab.Pane>
      <Header as='h3' textAlign='center' color='blue'>
      Permit To Work
    </Header>
      <Table celled compact  >
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Number</Table.HeaderCell>
        <Table.HeaderCell>Type</Table.HeaderCell>
        <Table.HeaderCell>Start Date</Table.HeaderCell>
        <Table.HeaderCell>End Date</Table.HeaderCell>
        <Table.HeaderCell>Start Time</Table.HeaderCell>
        <Table.HeaderCell>End Time</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {projectpermitsByTime.map((projectpermit, index) => (
        (projectpermit.code === 'new') ? 
        <Table.Row>
          <Table.Cell>
            {(project!.workType === 'TPG') ? <strong>CR</strong> :
             (project!.workType === 'Optus') ?
             <strong>PTW</strong> : ''} 
            <Input
              name="code"
              required
              onChange={handleInputChange}
              value={projectPermit.code}
              style={{width: '80px'}}
            />
          </Table.Cell>
          <Table.Cell >
          <Form.Select
            onChange={(e, { name, value }) =>
              setProjectPermit({ ...projectPermit, [name]: value })
            }
            name="type"
            options={typeOptions}
            value={projectPermit.type}
            style={{minWidth: '100px', width: '100px'}}
          />
          </Table.Cell>
          <Table.Cell>
          <Input
              name="startDate"
              type='date'
              onChange={handleInputChange}
              value={projectPermit.startDate}
              style={{width: '170px'}}
            />
          </Table.Cell>
          <Table.Cell>
          <Input
              name="endDate"
              type='date'
              onChange={handleInputChange}
              value={projectPermit.endDate}
              style={{width: '170px'}}
            />
          </Table.Cell>
          <Table.Cell>
            <Input
              name="startTime"
              type='time'
              onChange={handleInputChange}
              value={projectPermit.startTime}
              style={{width: '130px'}}
            />
            </Table.Cell>
          <Table.Cell>
          <Input
              name="endTime"
              type='time'
              onChange={handleInputChange}
              value={projectPermit.endTime}
              style={{width: '130px'}}
            />
          </Table.Cell>
          <Table.Cell>
            <Button.Group size="mini">
              <Button
                size="mini"
                content="submit"
                color="blue"
                onClick={() => createProjectPermit(projectPermit).then(() => setProjectPermit(initialPermitForm))}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        :
        
       <Table.Row key={projectpermit.id}>
          <Table.Cell>
            <strong>{projectpermit.code}</strong>
          </Table.Cell>
          <Table.Cell>{projectpermit.type}</Table.Cell>
          <Table.Cell>{(projectpermit.startDate !== null) ? 
          projectpermit.startDate.substr(0,10) : projectpermit.startDate}</Table.Cell>
          <Table.Cell>{(projectpermit.endDate !== null) ? 
          projectpermit.endDate.substr(0,10) : projectpermit.endDate}</Table.Cell>
          <Table.Cell>{projectpermit.startTime}</Table.Cell>
          <Table.Cell>{projectpermit.endTime}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Button.Group size="mini">
           { (index === projectpermitsByTime.length - 1) &&
              <Button
                size="mini"
                icon="add"
                color="green"
                title="Add new"
                onClick={() => addProjectPermit()}
              />}
              <Button
                name={projectpermit.id}
                size="mini"
                onClick={() => {
                  setOpenPermit(true);
                  setProjectPermitId(projectpermit.id);
                }}
                icon="delete"
                color="red"
                title="Delete"
              />
              <Confirm
                open={openPermit}
                onCancel={() => setOpenPermit(false)}
                onConfirm={() => {
                  deleteProjectPermit(projectpermitId);
                  setOpenPermit(false);
                }}
                content="Are you sure you want to delete ?"
                confirmButton="Yes"
                size="mini"
                style={{
                  position: "relative",
                  maxHeight: "150px",
                  height: "auto",
                }}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        
      ))}
    </Table.Body>
  </Table> 
  <Divider section/>
    <Grid>
      <Grid.Column width='11'>
      <Header as='h3' textAlign='center' color='blue'>
       Access
      </Header>
      <Table celled compact  >
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>BM Name</Table.HeaderCell>
        <Table.HeaderCell>Contact Email</Table.HeaderCell>
        <Table.HeaderCell>Phone</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {projectaccessByTime.map((projectaccess, index) => (
        (projectaccess.type === 'new') ? 
        <Table.Row>
          <Table.Cell>
            <Input
              name="companyName"
              required
              onChange={handleAccessInputChange}
              value={projectAccess.companyName}
              style={{width: '100px'}}
            />
          </Table.Cell>
          <Table.Cell>
            <Input
              name="email"
              required
              onChange={handleAccessInputChange}
              value={projectAccess.email}
              style={{width: '240px'}}
            />
          </Table.Cell>
          <Table.Cell>
            <Input
              name="phone"
              required
              onChange={handleAccessInputChange}
              value={projectAccess.phone}
              style={{width: '120px'}}
            />
          </Table.Cell>
          <Table.Cell >
          <Form.Select
            onChange={(e, { name, value }) =>
              setProjectAccess({ ...projectAccess, [name]: value })
            }
            name="status"
            options={statusOptions}
            value={projectAccess.status}
            style={{minWidth: '120px', width: '120px'}}
          />
          </Table.Cell>
          <Table.Cell>
            <Button.Group size="mini">
              <Button
                size="mini"
                content="submit"
                color="blue"
                onClick={() => createProjectAccess(projectAccess).then(() => setProjectAccess(initialAccessForm))}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        :
        
       <Table.Row key={projectaccess.id}>
          <Table.Cell>
            <strong>{projectaccess.companyName}</strong>
          </Table.Cell>
          <Table.Cell>{projectaccess.email}</Table.Cell>
          <Table.Cell>{projectaccess.phone}</Table.Cell>
          <Table.Cell>
          <Form.Select
            onChange={(e, { name, value }) =>
              updateProjectAccessStatus(value!.toString(), projectaccess)
            }
            name="status"
            options={statusOptions}
            value={projectaccess.status}
            style={{minWidth: '120px', width: '120px'}}
          />
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <Button.Group size="mini">
           { (index === projectaccessByTime.length - 1) &&
              <Button
                size="mini"
                icon="add"
                color="green"
                title="Add new"
                onClick={() => addProjectAccess()}
              />}
              <Button
                name={projectaccess.id}
                size="mini"
                onClick={() => {
                  setOpenAccess(true);
                  setProjectAccessId(projectaccess.id);
                }}
                icon="delete"
                color="red"
                title="Delete"
              />
              <Confirm
                open={openAccess}
                onCancel={() => setOpenAccess(false)}
                onConfirm={() => {
                  deleteProjectAccess(projectaccessId);
                  setOpenAccess(false);
                }}
                content="Are you sure you want to delete ?"
                confirmButton="Yes"
                size="mini"
                style={{
                  position: "relative",
                  maxHeight: "150px",
                  height: "auto",
                }}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        
      ))}
    </Table.Body>
  </Table> 
      </Grid.Column>
      <Grid.Column width='5'>
      <Header as='h3' color='blue'>
       Induction
      </Header>
      <Table basic='very' attached compact>
    <Table.Body>
    {TechInduction.map((induct: any) => {
     const tech = technicianallRegistry.get(induct.email)
    return ((tech) && <Table.Row key={induct.email}>
        <Table.Cell><Header as='h5' image>
         <Image avatar src={tech.photoUrl || "/assets/user.png"}/>
            <Header.Content>
            {tech.name}{tech.preferredName !== "" ? `  (${tech.preferredName})` : ""}
            </Header.Content>
          </Header></Table.Cell>
        <Table.Cell>{(induct.induction === 'N') ? 
          <Button
            size="mini"
            negative
            content="Not Inducted"
            title="Click to induct"
            onClick={() => editTechnicianInduction(project!.id, induct.email, 'Y')}
            style={{padding: '0.5em 0.5em'}}
            
          />
          :
          <Button
            size="mini"
            positive
            content="Inducted"
            title="Click to undo induction"
            onClick={() => editTechnicianInduction(project!.id, induct.email, 'N')}
            style={{padding: '0.5em 0.5em'}}
          />
        }
        </Table.Cell>
      </Table.Row>
    )})}    
    </Table.Body>
  </Table>
      </Grid.Column>
    </Grid>
    </Tab.Pane>
  );
};

export default observer(MobilePermitTab);
